// extracted by mini-css-extract-plugin
export var main = "BigPicture-module--main--JKaJp";
export var imageContainer = "BigPicture-module--imageContainer--27-K1";